import config from "config/config";
import { ErrorComponent, LinkBox, CTA, Image, PlainContent, SideBarHeading } from "../adapters/index";
import { Table, CheckList } from "../components";
import type { DynamicComponentProps } from "./DynamicComponent.d";

const developmentEnvironment = config.buildEnv === "development";

const Components = {
  heading: SideBarHeading,
  plain_content: PlainContent,
  image: Image,
  cta: CTA,
  table: Table,
  checklist: CheckList,
  linkBox: LinkBox,
};

const DynamicComponent = ({ component: { name, props } }: DynamicComponentProps) => {
  const Component = Components[name] || (developmentEnvironment && ErrorComponent);

  return <Component props={props} />;
};

export default DynamicComponent;
